import I18n from "^/config/i18n";

function setLanguage(page) {
  const lang = page.language() || "de";
  if (I18n.resolvedLanguage !== lang) {
    I18n.changeLanguage(lang);
  }
}
export default setLanguage;
